<div>
	<p>Please Register for Multi-Factor Authentication</p>

	<div>
		<p style="margin-bottom: 20px">Using your mobile phone please download either Google Authenticator or Microsoft Authenticator from the App Store</p>

		<!--App-Specific Instructions-->
		<div class="InstructionGrid">
			<!--Google Authenticator-->
			<div>
				<label>Google Authenticator Instructions:</label>
				<p>1. Open Google Authenticator</p>
				<p>
					2. Press the
					<i class="fa fa-plus-circle" aria-hidden="true"></i>
					button to add an account (bottom right)
				</p>
				<p>3. Pick the 'Scan a QR Code' option</p>
			</div>

			<!--Divider-->
			<div class="VerticalBorder"></div>

			<!--Microsoft Authenticator-->
			<div>
				<label>Microsoft Authenticator Instructions:</label>
				<p>1. Open Microsoft Authenticator</p>
				<p>
					2. Press the
					<i class="fa fa-ellipsis-v" aria-hidden="true"></i>
					button (top right)
				</p>
				<p>3. Select the '+ Add Account' option</p>
				<p>4. Select 'Other account (Google, Facebook, etc.)' (bottom option)</p>
				<p class="MAInstructionText">
					NOTE: If you have an existing entry in Microsoft Authenticator you must delete it before scanning the new QR code
				</p>
			</div>
		</div>

		<p style="margin-top: 15px">Scan the QR code below using either app to finish registering for MFA</p>
	</div>

	<img [src]="QRImage" class="QRImage" [alt]="ManualCode" />

	<div style="margin-bottom: 15px">
		<p>If you are unable to scan the image you can also enter the code:</p>
		<p>
			(NOTE: zeros will have a slash through them like
			<span style="font-family: monospace">0</span>)
		</p>
		<label style="font-size: 14px; font-family: monospace">{{ ManualCode }}</label>
	</div>
</div>
